import type { ReactNode } from 'react';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  delta?: ReactNode;
  accent?: 'gold';
}

export function StatTile({ label, value, delta, accent }: StatTileProps) {
  return (
    <div className="rounded-lg border border-border bg-card px-5 py-[18px] relative">
      <div className="mb-[10px] text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground/55">
        {label}
      </div>
      <div
        className={[
          'font-mono font-semibold text-[28px] leading-none tracking-tight',
          accent === 'gold' ? 'text-gold' : 'text-foreground',
        ].join(' ')}
      >
        {value}
      </div>
      {delta ? <div className="mt-[6px] text-[11px] text-foreground/55">{delta}</div> : null}
    </div>
  );
}
